module.exports = __webpack_public_path__ + "img/pause.92dfe04e.svg";